<template>
  <div>
    <Navbar :center-text="$t('TutorialView.tutorials')"
            :message="this.message"
            :message-type="this.messageType"></Navbar>
    <div class="container my-4">
      <div class="alert alert-info">
        <div class="row">
          <div class="col-md-4 col-sm-12 mb-2">
            <strong>{{$t('TutorialView.appStep1')}}</strong>
            <p>{{$t('TutorialView.appStep1Text')}}</p>
            <a :href="`https://play.google.com/store/apps/details?id=org.odk.collect.android&hl=${this.$i18n.locale}`"
               target="_blank">
              <img :src="localizedPlayStoreImage"
                   alt="Google Playstore Badge"
                   style="height: 3em; display: block; margin: auto;"/>
            </a>
          </div>
          <div class="col-md-4 col-sm-12 mb-2">
            <strong>{{$t('TutorialView.appStep2')}}</strong>
            <img src="@/assets/CANALLS_Platform_QR.png"
                 alt="ODK collect QR code"
                 style="height: 10em; display: block; margin: auto;"/>
          </div>
          <div class="col-md-4 col-sm-12 mb-2">
            <strong>{{$t('TutorialView.appStep3')}}</strong>
            <p>{{$t('TutorialView.appStep3YouCan')}}</p>
            <ul style="text-align: left;">
              <li>{{$t('TutorialView.appStep3AddFarmer')}}</li>
              <li>{{$t('TutorialView.appStep3AddActivity')}}</li>
              <li>{{$t('TutorialView.appStep3PerformDiagnostics')}}</li>
            </ul>
          </div>
        </div>
      </div>

      <TopicSectionComponent v-for="section in sections"
                             :topic-cards="section.cards"
                             :section-title="section.title">
      </TopicSectionComponent>

    </div>
  </div>
  <Footerbar></Footerbar>
</template>

<script>

import Navbar from "@/components/Navbar.vue";
import {sharedState} from "@/store";
import TopicSectionComponent from "@/views/TopicSectionComponent.vue";
import Footerbar from "@/components/Footerbar.vue";

export default {
  components: {Footerbar, TopicSectionComponent, Navbar},
  data() {
    return {
      sharedState,
      message: null,
      messageType: null,
    };
  },
  computed: {
    localizedPlayStoreImage() {
      const locale = this.$i18n.locale;
      return require(`@/assets/GooglePlay_Badge_${locale}.png`);
    },
    sections() {
      return [
        {
          'title': this.$t('TutorialView.tutorials'),
          'cards': [
            {
              'isEnabled': true,
              'title': this.$t('HomeView.setupTutorial'),
              'text': '',
              'link': '6a88cfe1-1dbc-4c48-abe5-1461f2c11fcd',
              'icon': 'bi-journal-bookmark',
              'embedPdf': true,
              'documentId': '6a88cfe1-1dbc-4c48-abe5-1461f2c11fcd',
              'thumbnailId': 'af88c5ff-d697-49b9-91e8-0df688f4349b',
            },
            {
              'isEnabled': true,
              'title': this.$t('HomeView.usingTutorial'),
              'text': '',
              'link': '',
              'icon': 'bi-journal-bookmark',
              'embedPdf': true,
              'documentId': '86186c9d-bdd1-4486-9d61-0bf36ac358a9',
              'thumbnailId': '25ca8849-7d4b-456d-a6ba-11dbc71af964',
            },
            {
              'isEnabled': true,
              'title': this.$t('HomeView.downloadTutorial'),
              'text': '',
              'link': '',
              'icon': 'bi-journal-bookmark',
              'embedPdf': true,
              'documentId': 'e7f0ee4c-07f7-4e83-985c-8506ead85da1',
              'thumbnailId': 'c5d199ef-2fda-4629-80fa-710be81aa364',
            },
          ],
        }
      ]
    }
  }
}
</script>